module.exports = __webpack_public_path__ + "static/media/feeling_stressed.3f60be06.svg";